import React, { useEffect, useRef, useState, useMemo } from "react";
import OrderConfirmationPopUp from "./orderConfirmationPopUp";
import { LABEL } from "../../veriables";
import styles from "./checksCommon.module.scss";
import cn from "classnames";
import { TouchableButton } from '@components/common/Touchable'

const SendOrderModeReVamp = (props) => {
  // Props Destructuring
  const {
    screenType,
    isOpen,
    onClose,
    deviceInfo,
    data,
    type,
    allMenusHashTable,
    menuItemsHashTable,
    cart,
    check,
    auth,
    serverAppTheme,
    orderModeStyle,
  } = props;

  const [isOpenPopUP, setIsOpenPopUP] = useState(false);
  const [selectedKey, setSelectedKey] = useState(null);
  const orderSendMode = deviceInfo?.deviceGroup?.orderSendModes;
  const Options = [
    { key: "toGo", label: LABEL().TOGO, isSuppoted: orderSendMode?.toGo },
    {
      key: "onTheFly",
      label: LABEL().ON_THE_FLY,
      isSuppoted: orderSendMode?.rush,
    },
    {
      key: "doNotMake",
      label: LABEL().DO_NOT_MAKE,
      isSuppoted: orderSendMode?.doNoMake,
    },
  ];
  const ref = useRef(null);
  const secondclick = isOpen ? true : false;

  useEffect(() => {
    if (secondclick) {
      return document.addEventListener("click", handleClickOutside, false);
    }
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [ref]);

  const onCloseFunc = (item) => {
    let orderTypes = false;
    if (check.sourceType != 11) {
      for (let index = 0; index < auth?.orderTypes.length; index++) {
        const element = auth?.orderTypes[index];
        if (element.printRouting === true) {
          orderTypes = true;
        }
      }
    }
    if (orderTypes === false) {
      onClose(item.key);
      return;
    }
    if (type === "sendSingle" || type === "send") {
      const groupItem = allMenusHashTable?.filter(
        (item) => item.id == data[0].menuScreenId,
      );
      if (
        groupItem[0]?.orderTypePrintRouting === true ||
        menuItemsHashTable[data[0].menuItemId]?.orderTypePrintRouting === true
      ) {
        setIsOpenPopUP(true);
        setSelectedKey(item.key);
      } else {
        onClose(item.key);
        return;
      }
    } else if (type === "sendAll" || type === "send all") {
      for (let index = 0; index < cart.length; index++) {
        const element = cart[index];
        const groupItem = allMenusHashTable?.filter(
          (item) => item.id == element?.menuScreenId,
        );
        if (
          groupItem[0]?.orderTypePrintRouting === true ||
          menuItemsHashTable[element.menuItemId].orderTypePrintRouting === true
        ) {
          setIsOpenPopUP(true);
          setSelectedKey(item.key);
          return;
        }
      }
      onClose(item.key);
      return;
    } else if (type === "send selected" || type === "sendSelect") {
      let cart = data;
      for (let index = 0; index < cart.length; index++) {
        const element = cart[index];
        const groupItem = allMenusHashTable?.filter(
          (item) => item.id == element.menuScreenId,
        );
        if (
          groupItem[0]?.orderTypePrintRouting === true ||
          menuItemsHashTable[element.menuItemId]?.orderTypePrintRouting === true
        ) {
          setIsOpenPopUP(true);
          setSelectedKey(item.key);
          return;
        }
      }
      onClose(item.key);
      return;
    }
  };

  const onClosePopUp = (type, arr, orderId) => {
    onClose(selectedKey, arr, orderId, type);
  };

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      onClose(false);
    }
  };

  const sendOrderModeInline = useMemo(() => {
    const optionsStyles = {
      height: "32px",
      background: serverAppTheme?.primaryBtn,
      color: serverAppTheme?.btn_font_color,
    };
    return { optionsStyles };
  }, [serverAppTheme]);

  return (
    isOpen && (
      <div
        ref={ref}
        className={cn(
          "col-12 px-0  h-auto position-absolute",
          screenType === "checklist" ? styles.sendOrderDivChecklist: styles.sendOrderDivOrder,
        )}
        style={{
          bottom:
            screenType === "orders" && orderModeStyle
              ? "20%"
              : screenType === "orders"
                ? "18%"
                : screenType === "checklist"
                  ? "10%"
                  : "24%",
        }}
      >
        <div
          style={{ background: serverAppTheme?.sendOrderModeBg, zIndex: '999999' }}
          className="col-12 p-1 rounded-top rounded-left h-auto "
        >
          {Options.filter((e) => e.isSuppoted).map((item, i) => {
            return (
              <TouchableButton
                role="presentation"
                onClick={(event) => {event.preventDefault(); onCloseFunc(item)}}
                className={cn(
                  "text-center row mx-0 justify-content-center align-items-center rounded w-100 border-0",
                  styles.sendOrderButtonDynamic,
                  i !== 0 && "mt-1",
                )}
                style={sendOrderModeInline.optionsStyles}
                rippleEffect={true}
              >
                {item.label}
              </TouchableButton>
            );
          })}
          {isOpenPopUP && (
            <OrderConfirmationPopUp
              isOpen={isOpenPopUP}
              pendingActionType={
                type === "sendSingle" || type === "send"
                  ? { type: type, data: { selectedItem: data } }
                  : type === "send selected" || type === "sendSelect"
                    ? { type: type, data: { selectedItem: data } }
                    : { type: type, data: { PendingItems: cart } }
              }
              actionTypes={type}
              seat={check}
              cart={cart}
              auth={auth}
              menusList={{ screens: allMenusHashTable }}
              menuItemsHashTable={menuItemsHashTable}
              onClose={onClosePopUp}
            />
          )}
        </div>
        <div className="col-12 px-0 pl-3 d-flex flex-row-reverse">
          <div
            className="px-0 "
            style={{
              height: "10px",
              width: '41%',
              background: serverAppTheme?.sendOrderModeBg,
            }}
          ></div>
        </div>
        {/* <div className="col-12 px-0 pl-3 d-flex flex-row-reverse">
          <div
            className="px-0 "
            style={{
              // height:  "10px",
              width:
                screenType === "orders"
                  ? "41.3%"
                  : screenType === "checklist"
                    ? "40%"
                    : "24%",
              // background: serverAppTheme?.sendOrderModeBg,
            }}
          ></div>
        </div> */}
      </div>
    )
  );
};

export default SendOrderModeReVamp;
